import { useState, useCallback } from 'react';

export const useCheckoutLoading = (initialLoadingStates: string[] = ['initial']) => {
  const [loading, setLoading] = useState<Set<string>>(new Set(initialLoadingStates));

  const addLoading = useCallback((state: string) => {
    setLoading(prev => new Set(prev).add(state));
  }, []);

  const removeLoading = useCallback((state: string) => {
    setLoading(prev => {
      const newLoading = new Set(prev);
      newLoading.delete(state);
      return newLoading;
    });
  }, []);

  const clearLoading = useCallback(() => {
    setLoading(new Set());
  }, []);

  const isLoading = useCallback((state: string) => {
    return loading.has(state);
  }, [loading]);

  const hasAnyLoading = useCallback(() => {
    return loading.size > 0;
  }, [loading]);

  const hasActiveLoading = useCallback((excludeInitial = true) => {
    if (excludeInitial) {
      return Array.from(loading).some(state => state !== 'initial');
    }
    return loading.size > 0;
  }, [loading]);

  return {
    loading,
    addLoading,
    removeLoading,
    clearLoading,
    isLoading,
    hasAnyLoading,
    hasActiveLoading,
  };
}; 